import { Button } from 'hatch-components';
import styled from 'styled-components';

export const StyledButton = styled(Button)(
  ({
    theme: {
      font,
      colors,
      spacing,
      responsive: { mobile },
    },
  }) => ({
    fontSize: font.size.sm,
    height: 48,
    [mobile]: {
      '&:hover, &:active, &:focus': {
        background: colors.primaryTint,
        color: colors.white,
      },
      alignItems: 'center',
      background: colors.primary,
      borderRadius: '100%',
      color: colors.white,
      display: 'flex',
      fontSize: font.size.sm,
      height: spacing.md,
      justifyContent: 'center',
      lineHeight: spacing.md,
      minHeight: 0,
      minWidth: 0,
      padding: spacing.xxxs,
      span: {
        display: 'none',
      },
      width: spacing.md,
    },
  }),
);
